export default __webpack_public_path__ + "static/media/drawing.13c910e0.svg";